// Date 2020-11-01 17:04:45

import emMenu from "@/store/em/admin/EmMenuStore.js";
import emAclRole from "@/store/em/admin/EmAclRoleStore.js";
import emAclUser from "@/store/em/admin/EmAclUserStore.js";
import emCssIcon from "@/store/em/admin/EmCssIconStore.js";
import emMenuType from "@/store/em/admin/EmMenuTypeStore.js";
import emViewCrudState from "@/store/em/admin/EmViewCrudStateStore.js";
import emAttachment from "@/store/em/admin/EmAttachmentStore.js";
import emAclDept from "@/store/em/admin/EmAclDeptStore.js";
import emAclRoleAcl from "@/store/em/admin/EmAclRoleAclStore.js";
import emAclRoleUser from "@/store/em/admin/EmAclRoleUserStore.js";
import emAdmSysLog from "@/store/em/admin/EmAdmSysLogStore.js";
import emAdmSysParam from "@/store/em/admin/EmAdmSysParamStore.js";
import emAdmNotification from "@/store/em/admin/EmAdmNotificationStore.js";
import emAdmSysOperateLog from "@/store/em/admin/EmAdmSysOperateLogStore.js";
import emAclLocationType from "@/store/em/admin/EmAclLocationTypeStore";
import emAclLocation from "@/store/em/admin/EmAclLocationStore.js";
import emAdmFactoryModelEafm from "@/store/em/admin/EmAdmFactoryModelEafmStore.js";
import emAdmFactoryModelTypeEafmt from "@/store/em/admin/EmAdmFactoryModelTypeEafmtStore.js";
import emAdmRoleTag from "@/store/em/admin/EmAdmRoleTagStore.js";
import imfMstLocation from "@/store/em/admin/ImfMstLocationStore.js";
import imfMstLocationShiftRule from "@/store/em/admin/ImfMstLocationShiftRuleStore.js";
import imfMstShift from "@/store/em/admin/ImfMstShiftStore.js";
import imfMstShiftRule from "@/store/em/admin/ImfMstShiftRuleStore.js";
import imfMstShiftTeam from "@/store/em/admin/ImfMstShiftTeamStore.js";
import imfMstShiftTime from "@/store/em/admin/ImfMstShiftTimeStore.js";
import imfMstCalendar from "@/store/em/admin/ImfMstCalendarStore.js";
import imfMstShiftTeamUser from "@/store/em/admin/ImfMstShiftTeamUserStore.js";
import imfMstLocationTagLoct from "@/store/em/admin/ImfMstLocationTagLoctStore.js";
import emAdmGroup from "@/store/em/admin/EmAdmGroupStore.js";
import emAdmOrganization from "@/store/em/admin/EmAdmOrganizationStore.js";
import emAclUserType from "@/store/em/admin/EmAclUserTypeStore.js";
import emAclUserJob from "@/store/em/admin/EmAclUserJobStore.js";
import emAdmUserTag from "@/store/em/admin/EmAdmUserTagStore.js";
import emDictType from "@/store/em/admin/EmDictTypeStore.js";
import emDictData from "@/store/em/admin/EmDictDataStore.js";
import emEmAdmUserGroup from "@/store/em/admin/EmEmAdmUserGroupStore.js";
import emEmAdmUserGroupRole from "@/store/em/admin/EmEmAdmUserGroupRoleStore.js";
import businessModule from "@/store/em/admin/BusinessModuleStore";

const genericEntities = [
    'emMenu',
    'emAclRole',
    'emAclUser',
    'emCssIcon',
    'emMenuType',
    'emViewCrudState',
    'emAttachment',
    'emAclDept',
    'emAclRoleAcl',
    'emAclRoleUser',
    'emAdmSysLog',
    'emAdmSysParam',
    'emAdmSysOperateLog',
    'emAdmNotification',
    'emAclLocationType',
    'emAclLocation',
    'emAdmFactoryModelEafm',
    'emAdmFactoryModelTypeEafmt',
    'emAdmRoleTag',
    'imfMstLocation',
    'imfMstLocationShiftRule',
    'imfMstShift',
    'imfMstShiftRule',
    'imfMstShiftTeam',
    'imfMstShiftTime',
    'imfMstCalendar',
    'imfMstShiftTeamUser',
    'imfMstLocationTagLoct',
    'emAdmGroup',
    'emAdmOrganization',
    'emAclUserType',
    'emAclUserJob',
    'emAdmUserTag',
    'emDictType',
    'emDictData',
    'emEmAdmUserGroup',
    'businessModule'

]

const entities = {
    emMenu,
    emAclRole,
    emAclUser,
    emCssIcon,
    emMenuType,
    emViewCrudState,
    emAttachment,
    emAclDept,
    emAclRoleAcl,
    emAclRoleUser,
    emAdmSysLog,
    emAdmSysParam,
    emAdmSysOperateLog,
    emAdmNotification,
    emAclLocationType,
    emAclLocation,
    emAdmFactoryModelEafm,
    emAdmFactoryModelTypeEafmt,
    emAdmRoleTag,
    imfMstLocation,
    imfMstLocationShiftRule,
    imfMstShift,
    imfMstShiftRule,
    imfMstShiftTeam,
    imfMstShiftTime,
    imfMstCalendar,
    imfMstShiftTeamUser,
    imfMstLocationTagLoct,
    emAdmGroup,
    emAdmOrganization,
    emAclUserType,
    emAclUserJob,
    emAdmUserTag,
    emDictType,
    emDictData,
    emEmAdmUserGroup,
    emEmAdmUserGroupRole,
    businessModule
}

export {genericEntities}

export default entities
